import { concat } from '@ember/helper';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismIcon, PrismTooltipHeader } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

interface HotelStrategyTooltipsTooltipChartSignature {
  Args: {
    label: unknown;
    position: unknown;
  };
}

export default class HotelStrategyTooltipsTooltipChart extends Component<HotelStrategyTooltipsTooltipChartSignature> {
  @service declare rsSelections: Services['rs-selections'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get compsetSize() {
    return this.rsSelections?.compsetSize;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasArrowDownIcon() {
    // @ts-expect-error: Incorrect type
    return this.args.position.subtypePosition > this.usualPricePoint;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isSameAsUsualPricePoint() {
    // @ts-expect-error: Incorrect type
    return this.args.position.subtypePosition === this.usualPricePoint;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get usualPricePoint() {
    return this.rsSelections?.usualPricePoint;
  }

  <template>
    {{! @glint-nocheck }}
    <div class="default-tooltip default-tooltip--large default-table-tooltip">
      <PrismTooltipHeader>
        {{@label}}
      </PrismTooltipHeader>
      <table class="default-table">
        <tbody>
          <tr>
            <td class="flex items-center justify-between gap-100">
              {{t "strategy.avg_best_available_rate"}}
              <div
                class="button--unstyled position-badge position-badge--primary"
              >
                {{t
                  "strategy.metric_block.your_position"
                  position=(concat this.usualPricePoint "/" this.compsetSize)
                }}
              </div>
            </td>
          </tr>
          <tr>
            <td class="flex items-center justify-between gap-100">
              {{@label}}
              {{#if this.isSameAsUsualPricePoint}}
                <div class="button--unstyled position-badge">
                  {{t
                    "strategy.metric_block.your_position"
                    position=@position.formattedSubtypePosition
                  }}
                </div>
              {{else}}
                <div
                  class="button--unstyled position-badge position-badge--warning"
                >
                  {{t
                    "strategy.metric_block.your_position"
                    position=@position.formattedSubtypePosition
                  }}
                  <PrismIcon
                    @name={{if this.hasArrowDownIcon "arrow-down" "arrow-up"}}
                    @size="small"
                    class="ml-100"
                  />
                </div>
              {{/if}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
}
